export default __webpack_public_path__ + "e8edf9aa91ba40801a512fd4d8859e6e.png";